import { render, staticRenderFns } from "./SearchFacetValue.vue?vue&type=template&id=052646da&"
import script from "./SearchFacetValue.vue?vue&type=script&lang=js&"
export * from "./SearchFacetValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports